// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bbbsnyokokecqttelcxi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJiYnNueW9rb2tlY3F0dGVsY3hpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA1MjI2NTksImV4cCI6MjA2NjA5ODY1OX0.A-7T4CYZ6VorD1RGdABNaZmJZHofJXhlNbpte9T0IeM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);